import brokenCar from 'static/img/icons/broken_car.svg';
import discount from 'static/img/icons/discount.svg';
import heart from 'static/img/icons/heart.svg';
import LandingSection from 'components/landing/components/landing-section';
import moneyEnvelope from 'static/img/icons/money_envelope.svg';
import requirements from 'static/img/icons/requirements.svg';
import Text from 'core/text';
import TextBox from 'core/text-box';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';

const WhoNeeds = () => {
    const { seoText, verification } = useGetSeoTextByIndex('who_needs');

    if (!verification) {
        // TODO: Add sentry controlled exception
        return null;
    }

    return (
        <LandingSection>
            <Title content={seoText.section_title} preTitle={seoText.section_subtitle} />
            <Text
                content={seoText.paragraph1.sentence1}
                width="auto"
                marginBottom="40px"
                marginTop="40px"
            />
            <div className="paragraph_wrapper">
                <TextBox
                    title={seoText.item1.title}
                    content={seoText.item1.sentence1}
                    containerWidth="360px"
                    image={requirements}
                    align
                />
                <TextBox
                    title={seoText.item2.title}
                    content={seoText.item2.sentence1}
                    containerWidth="360px"
                    image={moneyEnvelope}
                    align
                />
                <TextBox
                    title={seoText.item3.title}
                    content={seoText.item3.sentence1}
                    containerWidth="360px"
                    image={heart}
                    align
                />
                <TextBox
                    title={seoText.item4.title}
                    content={seoText.item4.sentence1}
                    containerWidth="360px"
                    image={brokenCar}
                    align
                />
                <TextBox
                    title={seoText.item5.title}
                    content={seoText.item5.sentence1}
                    containerWidth="360px"
                    image={discount}
                    align
                />
            </div>
        </LandingSection>
    );
};

export default WhoNeeds;
